module.exports = __webpack_public_path__ + "images/emoji/pineapple.2c1e61b569ffacfbc065.png";